(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-dibuli-select-pack]');
    if (!link) return;
    const radio = document.querySelector('.dibuli-offer-option--bestseller .dibuli-offer-picker__radio');
    if (radio && !radio.disabled) radio.click();
  });
  const mount = () => {
    const bar = document.querySelector('[data-dibuli-mobile-bar]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const buyButton = document.querySelector('product-form [type="submit"]');
    const drawer = document.querySelector('cart-drawer');
    let scrolledPastButton = false;
    const updateVisibility = () => {
      bar.hidden = !scrolledPastButton || Boolean(drawer?.classList.contains('active'));
    };
    if (buyButton && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        const entry = entries[0];
        scrolledPastButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        updateVisibility();
      }).observe(buyButton);
    }
    if (drawer) new MutationObserver(updateVisibility).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('change', (event) => {
      if (!event.target.matches('.dibuli-offer-picker__radio')) return;
      const price = event.target.parentElement.querySelector('.dibuli-offer-card__price');
      const target = bar.querySelector('[data-dibuli-mobile-price]');
      if (price && target) target.textContent = price.textContent.trim();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
